import React, { useState } from "react";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ConceptualRootForm from "./ConceptualRootForm";
import ConceptualRootList from "./ConceptualRootList";
import { ManagementLayout, Can } from "@components/shared";
import { PERMISSIONS } from "@util/permissions";

export default function ConceptualRootManagement() {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ManagementLayout
      dataComponent={<ConceptualRootList refresh={refresh} />}
      createComponent={
        <Can permission={PERMISSIONS.CONCEPTUAL_ROOTS_CREATE}>
          <Card>
            <Title order={4}>{t("create")} Conceptual Root</Title>
            <ConceptualRootForm
              onSuccess={(root) => {
                setRefresh(!refresh);
                if (root?.id) navigate(`/conceptual-roots/${root.id}`);
              }}
            />
          </Card>
        </Can>
      }
    />
  );
}
